import React from 'react';
import PercentageCircle from '@gp/components/PercentageCircle';
import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
import { newMathFormatForcePadEndZeroWrapper as newMathFormat, formatDateStr } from '@gp/utils/common';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IBaseProps } from '@home/types/common';

export interface ISpendDateData {
  launch?: string;
  dev_budget_date?: string;
  spend_to_date?: string;
  of_total_budget?: string;
}

interface ISpendDateProps extends IBaseProps {
  data?: ISpendDateData;
}

const SpendDate: React.FC<ISpendDateProps> = (props) => {
  const { data } = props;
  const {
    launch,
    dev_budget_date: devBudgetDate,
    spend_to_date: spendToDate,
    of_total_budget: ofTotalBudget,
  } = data || {};
  const devBudgetDateFormatted = formatDateStr(devBudgetDate, 'YYYY-MM');

  return (
    <div className="dbg-finance-card-flex">
      <div className="dbg-finance-card-left-spend">
        <div className="dbg-finance-card-num">{newMathFormat(spendToDate, true)}</div>
        <div className="dbg-finance-card-text dbg-finance-card-text--spend-to-date-new">
          <div className="dbg-finance-card-text-item">
            <MultipleLinesTextBubble
              fields={FIELDS1}
              names={FIELD_NAMES}
              data={{
                definition:
                  'Research & Development Staff Cost + Outsourcing + Other Research & Development Expenses - Video Games Tax Relief (If Any)',
                source: 'Gate Review Documents',
                updateCadence: 'By Milestone',
              }}
            >
              <div className="dbg-finance-card-label">{CONSTANT_TEXTS.APPROVED_DEVELOPMENT_BUDGET}</div>
            </MultipleLinesTextBubble>
            <div className="dbg-finance-card-desc">
              <span>{newMathFormat(launch, true)}</span>
              {!!devBudgetDateFormatted && <span className="dbg-finance-card-time">{devBudgetDateFormatted}</span>}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          height: '100%',
          width: '100%',
          textAlign: 'center',
          // display: 'flex',
          // justifyContent: ' space-evenly',
        }}
      >
        <div>
          <PercentageCircle
            style={{ width: '100%', height: 50, margin: 'auto' }}
            value={ofTotalBudget ? Math.round(Number.parseFloat(ofTotalBudget) * 100) : 0}
          />
          <div
            style={{
              lineHeight: 1,
              textAlign: 'center',
              fontWeight: 400,
              fontSize: 12,
              whiteSpace: 'nowrap',
              color: '#9B9FB0',
            }}
          >
            % of Approved <br /> Dev Budget
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpendDate;
